// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/type/tag_ref.proto (package wisetime.user.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/type/tag_ref.proto.
 */
export const file_wisetime_user_type_tag_ref: GenFile = /*@__PURE__*/
  fileDesc("CiB3aXNldGltZS91c2VyL3R5cGUvdGFnX3JlZi5wcm90bxISd2lzZXRpbWUudXNlci50eXBlIjMKBlRhZ1JlZhIPCgdzaXRlX2lkGAIgASgJEgoKAmlkGAEgASgJEgwKBG5hbWUYBCABKAlCKwoaY29tLndpc2V0aW1lLmFwaS51c2VyLnR5cGVCC1RhZ1JlZlByb3RvUAFiBnByb3RvMw");

/**
 * A reference to a legebill.type.Tag.
 *
 * @generated from message wisetime.user.type.TagRef
 */
export type TagRef = Message<"wisetime.user.type.TagRef"> & {
  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * E.g. WT-1234
   *
   * @generated from field: string name = 4;
   */
  name: string;
};

/**
 * Describes the message wisetime.user.type.TagRef.
 * Use `create(TagRefSchema)` to create a new message.
 */
export const TagRefSchema: GenMessage<TagRef> = /*@__PURE__*/
  messageDesc(file_wisetime_user_type_tag_ref, 0);

